import { useEffect } from "react";
import {  useGetUserQuery } from "../api/appAPI";
import { useAuth  } from "./useAuthToken";
import { store } from "../store";
import { removeAuth, setAppAuth } from "../store/appSlice";

export const useIsAuthenticated = ():boolean => {
  
  const auth = useAuth();
  
  const { data, error, isLoading } = useGetUserQuery();

  useEffect(()=>{
      if(auth) {
        return;
      }
      if(isLoading) {
          return;
      }
      if(error) {
          console.log('authenticated error', error);
          store.dispatch(removeAuth());
      } else {
          if(data) {
            store.dispatch(setAppAuth({'username': data.username, 'expire': data.expire}));
          }
      }
  }, [auth, isLoading, data, error]);
  return typeof(auth) != "undefined";
}
